import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Scrollbars } from 'react-custom-scrollbars';
import { useLazyQuery, useQuery } from 'react-apollo';
import MessageContainer from './MessageContainer';
import ParticipatingArtistList from './ParticipatingArtistList';
import PendingContractList from './PendingContractList';
import RejectedArtistList from './RejectedArtistList';
import SearchContainer from './SearchContainer';
import {
  GET_OFFER_PARTICIPATING_ARTIST, GET_PENDING_CONTRACT_ARTIST, GET_UNSEEN_MESSAGES,
} from '../../../../graphql-client/queries';
import { NO_REQUEST_ICON, NUMERIC_VALUE, OFFER_DETAIL_LISTING } from '../../../../utils';

function OfferMessageList(props) {
  const [participatingQueryObj, setParticipatingQueryObj] = useState({ page: 1, limit: NUMERIC_VALUE.FIVE });
  const [pendingQueryObj, setPendingQueryObj] = useState({ page: 1, limit: NUMERIC_VALUE.FIVE });
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [messageModalObj, setMessageModalObj] = useState(null);
  const [searchKey, setSearchKey] = useState(null);
  const [participatingCount, setParticipatingCount] = useState();
  const [pendingContractCount, setPendingContract] = useState();
  const [rejectedArtistCount, setRejectedArtistCount] = useState();
  const [broadcastArtistList, setBroadcastArtistList] = useState(null);
  const [isCountApplied, setIsCountApplied] = useState(false);
  const { offerId, offerMaxDate } = props;
  const { data: unreadConversations } = useQuery(GET_UNSEEN_MESSAGES);

  const [getParticipatingArtistList, { loading, data: participatingArtistList, refetch: refreshParticipatingArtistList }] = useLazyQuery(GET_OFFER_PARTICIPATING_ARTIST,
    { variables: { offerId, ...participatingQueryObj }, fetchPolicy: 'cache-and-network' });

  const [getPendingArtistList, { data: pendingArtistList }] = useLazyQuery(GET_PENDING_CONTRACT_ARTIST,
    { variables: { offerId, ...participatingQueryObj }, fetchPolicy: 'cache-and-network' });

  useEffect(() => {
    getPendingArtistList();
    getParticipatingArtistList();
  }, []);

  useEffect(() => {
    if (pendingArtistList && participatingArtistList && !broadcastArtistList) {
      const artistList = [...pendingArtistList.artistPendingContract.data, ...participatingArtistList.participatingOfferArtist.data];
      setBroadcastArtistList(artistList.map((el) => el.userId));
    }
  }, [pendingArtistList, participatingArtistList]);

  useEffect(() => {
    if (broadcastArtistList && showMessageModal) {
      setMessageModalObj({ artistDetail: broadcastArtistList, offerId, isBroadCast: true });
    }
  }, [broadcastArtistList]);

  const closeMessageModal = () => {
    setMessageModalObj(null);
    setShowMessageModal(false);
  };

  function getSearchKey(key) {
    setSearchKey(key);
  }

  function setListingCount(status, count) {
    switch (status) {
      case OFFER_DETAIL_LISTING.PARTICIPATING_ARTIST:
        setParticipatingCount(count);
        setIsCountApplied(true);
        break;
      case OFFER_DETAIL_LISTING.PENDING_CONTRACT:
        setPendingContract(count);
        setIsCountApplied(true);
        break;
      case OFFER_DETAIL_LISTING.REJECTED_ARTIST:
        setRejectedArtistCount(count);
        setIsCountApplied(true);
        break;
      default:
        break;
    }
  }
  const checkList = (participatingCount > 0 || pendingContractCount > 0 || rejectedArtistCount > 0);

  const broadcastMessage = () => {
    if (!broadcastArtistList) {
      getPendingArtistList();
      getParticipatingArtistList();
      setShowMessageModal(true);
    } else {
      setShowMessageModal(true);
      setMessageModalObj({ artistDetail: broadcastArtistList, offerId, isBroadCast: true });
    }
  };

  const hasUnreadMessage = (userId) => {
    if (unreadConversations) {
      return unreadConversations.unseenMessages.find((el) => el.unseenMessage
                   && el.offerId === offerId && el.senderId === userId);
    }
    return null;
  };

  const handleParticipatingLMData = (page) => {
    refreshParticipatingArtistList({
      page,
      offerId,
      limit: NUMERIC_VALUE.FIVE,
    });
  };

  return (
    <>
      <div className="offer-message-wrapper">
        {checkList && (
          <>
            <SearchContainer search={getSearchKey} />
          </>
        )}
        { broadcastArtistList && broadcastArtistList.length
          ? (
            <span className="message-all-btn" onClick={broadcastMessage}>Message all Artists on this opportunity</span>
          ) : ''}
        <div className={`offer-message-list-wrapper ${!checkList && 'd-none'}`}>
          <Scrollbars
            style={{ height: '100%' }}
            thumbMinSize={30}
          >
            <ParticipatingArtistList
              offerId={offerId}
              searchKey={searchKey}
              loading={loading}
              loadMoreData={handleParticipatingLMData}
              participatingData={participatingArtistList?.participatingOfferArtist}
              listingCount={setListingCount}
              setShowMessageModal={setShowMessageModal}
              setMessageModalObj={setMessageModalObj}
              messageModalObj={messageModalObj}
              hasUnreadMessage={hasUnreadMessage}
            />
            <PendingContractList
              offerId={offerId}
              searchKey={searchKey}
              listingCount={setListingCount}
              setShowMessageModal={setShowMessageModal}
              setMessageModalObj={setMessageModalObj}
              hasUnreadMessage={hasUnreadMessage}
              messageModalObj={messageModalObj}
              offerMaxDate={offerMaxDate}
            />
            <RejectedArtistList
              offerId={offerId}
              searchKey={searchKey}
              listingCount={setListingCount}
            />
          </Scrollbars>
        </div>
        {
          (isCountApplied && (participatingCount === 0 && pendingContractCount === 0
          && rejectedArtistCount === 0)) && (
          <div className="no-message-section">
            <div className="no-request-content">
              <h1>No Participating artist yet.</h1>
              <img
                src={NO_REQUEST_ICON}
                alt="request"
              />
            </div>
          </div>
          )
        }
      </div>
      {showMessageModal && messageModalObj && (
      <MessageContainer
        isShow={showMessageModal}
        onClose={() => { closeMessageModal(); }}
        messageModalObj={messageModalObj}
        offerMaxDate={offerMaxDate}
      />
      )}
    </>
  );
}

OfferMessageList.propTypes = {
  offerId: PropTypes.string.isRequired,
  offerMaxDate: PropTypes.string,
};

OfferMessageList.defaultProps = {
  offerMaxDate: null,
};

export default OfferMessageList;
